define("shared/components/shared/social/tiktok-details", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @close={{@handleClose}} as |modal|>
    <modal.card @portrait={{true}}>
      <modal.card-header @title={{t "tiktok.guide.title"}} />
      <modal.card-body class="u--p__t__0">
        <p>{{html-safe (t "tiktok.guide.body")}}</p>
      </modal.card-body>
      <modal.card-footer>
        <div class="o--btnBar u--float--right">
          <Shared::Ui::Button @onClick={{@handleClose}} @text={{t "shared_words.close"}} @variant="mute" />
        </div>
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "/QUTSBGg",
    "block": "[[[8,[39,0],null,[[\"@close\"],[[30,1]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,2,[\"card-header\"]],null,[[\"@title\"],[[28,[37,1],[\"tiktok.guide.title\"],null]]],null],[1,\"\\n    \"],[8,[30,2,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,2],[12],[1,[28,[35,2],[[28,[37,1],[\"tiktok.guide.body\"],null]],null]],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,2,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"o--btnBar u--float--right\"],[12],[1,\"\\n        \"],[8,[39,3],null,[[\"@onClick\",\"@text\",\"@variant\"],[[30,1],[28,[37,1],[\"shared_words.close\"],null],\"mute\"]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[2]]]]]],[\"@handleClose\",\"modal\"],false,[\"shared/modal\",\"t\",\"html-safe\",\"shared/ui/button\"]]",
    "moduleName": "shared/components/shared/social/tiktok-details.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});